/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Custom_TextInputs */



/**
* | output |
* | --- |
* | "Custom text" |
*
* @param {Options_Watermark_Custom_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_custom_text = /** @type {((inputs?: Options_Watermark_Custom_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Custom_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte personnalisé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefinierter Text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo personalizzato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Произвольный текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto personalizado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自定义文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタムテキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम टेक्स्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto personalizado")
	return /** @type {LocalizedString} */ ("Custom text")
});